module.exports = __webpack_public_path__ + "static/media/statistics-mobile-left-btm-bg.04983a6a.svg";